export default __webpack_public_path__ + "static/media/logoWhiteEN.29f29a06.png";